export default __webpack_public_path__ + "static/media/aanmelden.b3d56309.png";